module.exports = __webpack_public_path__ + "static/media/ceilings-001-thumbnail.6b0c9b49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/thumbnails/ceilings-001-thumbnail.jpg
// module id = 101
// module chunks = 0